import r from"react";import{Icon as o}from"@mdi/react";const e=e=>r.createElement(o,{size:1,color:"currentColor",...e});export{e as MdIcon};
